"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FunnelSectionPath = exports.FunnelSection = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _internals = require("@mui/x-charts/internals");
var _hooks = require("@mui/x-charts/hooks");
var _clsx = _interopRequireDefault(require("clsx"));
var _funnelSectionClasses = require("./funnelSectionClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["seriesId", "dataIndex", "classes", "color", "onClick", "className", "variant"];
const FunnelSectionPath = exports.FunnelSectionPath = (0, _styles.styled)('path')(() => ({
  transition: 'opacity 0.2s ease-in, fill 0.2s ease-in, fill-opacity 0.2s ease-in, filter 0.2s ease-in'
}));

/**
 * @ignore - internal component.
 */
const FunnelSection = exports.FunnelSection = (0, _internals.consumeSlots)('MuiFunnelSection', 'funnelSection', {
  classesResolver: _funnelSectionClasses.useUtilityClasses
}, /*#__PURE__*/React.forwardRef(function FunnelSection(props, ref) {
  const {
      seriesId,
      dataIndex,
      classes,
      color,
      onClick,
      className,
      variant = 'filled'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const interactionProps = (0, _internals.useInteractionItemProps)({
    type: 'funnel',
    seriesId,
    dataIndex
  });
  const {
    isFaded,
    isHighlighted
  } = (0, _hooks.useItemHighlighted)({
    seriesId,
    dataIndex
  });
  const isOutlined = variant === 'outlined';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FunnelSectionPath, (0, _extends2.default)({}, interactionProps, {
    filter: isHighlighted && !isOutlined ? 'brightness(120%)' : undefined,
    opacity: isFaded && !isOutlined ? 0.3 : 1,
    fill: color,
    stroke: isOutlined ? color : 'none',
    fillOpacity: isOutlined && !isHighlighted ? 0.4 : 1,
    strokeOpacity: 1,
    strokeWidth: isOutlined ? 1.5 : 0,
    cursor: onClick ? 'pointer' : 'unset',
    onClick: onClick,
    className: (0, _clsx.default)(classes?.root, className, isOutlined ? classes?.outlined : classes?.filled, isHighlighted && classes?.highlighted, isFaded && classes?.faded)
  }, other, {
    ref: ref
  }));
}));